import { render } from "./FavIcon.vue?vue&type=template&id=3bad9e11&ts=true"
import script from "./FavIcon.vue?vue&type=script&lang=ts"
export * from "./FavIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.13_vue@3.5.13_typescript@4.5.5__webpack@5.99.5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__